module.exports = __webpack_public_path__ + "static/media/deboraEquipe.3a74f845.jpg";